export enum MediaType {
  textXml = 'text/xml',
  applicationJson = 'application/json',
  applicationPdf = 'application/pdf',
  applicationXlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  multipartFormData = 'multipart/form-data',
}
